//Import React Router Dom
import { BrowserRouter, Routes, Route } from "react-router-dom";

//Import React Query
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

//Import Root component to wrap all pages
import { Root } from "./Root";

//Import Pages
import Home from "../pages/Home";
import About from "../pages/About";
import Account from "../pages/Account";
import Profile from "../pages/Profile";
import Error404 from "../pages/Error404";

var queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 1,					// Retry failed requests once
			staleTime: 1000 * 60 * 1,	// Data is fresh for 1 minutes
		},
	},
});

export function Router() {
	return <BrowserRouter>
        <QueryClientProvider client={queryClient}>
			<Root>
				<Routes>
					<Route index element={<Home />} />
					<Route path="/about/*" element={<About />} />
					<Route path="/account/*" element={<Account />} />
					<Route path="/profile/*" element={<Profile />} />
					<Route path="*" element={<Error404 />} />
				</Routes>
			</Root>
        </QueryClientProvider>
	</BrowserRouter>;
}